import * as React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { pageNavsStore } from '@src/shared/store/navs';
import Recovery from '@src/shared/components/Recovery';
import { buildCacheKey } from '@shared/utils';
import AnalysisSetting from './AnalysisSetting';
import DimensionSetting from './DimensionSetting';
import EventSetting from './EventSetting';

type DashboardSettingsParams = {
  setting: 'event' | 'dimension';
  id?: string;
};

const SETTING_COMPONENT_MAP = {
  default: AnalysisSetting,
  dimension: DimensionSetting,
  event: EventSetting,
};

function buildCacheFeatureKey(state?: DashboardSettingsParams) {
  if (state?.setting && state.id) return `${state.setting}:${state.id}` as const;

  if (state?.setting) return state.setting;

  return undefined;
}

const patchNav = pageNavsStore.getState().patch;

const DashboardSettings = () => {
  const { id } = useParams() as { id: string };
  const { state } = useLocation() as { state?: DashboardSettingsParams };
  const cacheKey = buildCacheKey(id, buildCacheFeatureKey(state));

  // Patch dashboard store if there is state from navigation
  React.useEffect(() => {
    if (id && state?.setting) {
      patchNav(id, { state });
    } else if (id) {
      patchNav(id, { state: undefined });
    }
  }, [id, state]);

  const SettingComponent = SETTING_COMPONENT_MAP[state?.setting ?? 'default'];

  return (
    <Recovery cacheKey={cacheKey} cleanupOnKeyChange>
      <SettingComponent id={state?.id} />
    </Recovery>
  );
};

export default React.memo(DashboardSettings);
